// class CSVExporter {
//     constructor(fields, companies) {
//         this.fields = fields
//         this.companies = companies
//     }
// }


function getPrimaryContact(company) {
    if(company.contacts){
        let primaryContacts = []
        company.contacts.forEach((contact) => {
            if(contact.is_primary_contact){
                primaryContacts.push(contact)
            }
        })
        return primaryContacts.length > 0 ? primaryContacts[0] : null
    } else {
        return null
    }
}


function getPrimaryContactFullName(company) {
    let fullName = ''
    const primaryContact = getPrimaryContact(company)
    if(primaryContact){
        if(primaryContact.contact.middle_name){
            fullName = `${primaryContact.contact.first_name} ${primaryContact.contact.middle_name} ${primaryContact.contact.last_name}`
        } else {
            fullName = `${primaryContact.contact.first_name} ${primaryContact.contact.last_name}`
        }
    }
    return fullName
}

function getPrimaryContactPreferredName(company) {
    let preferredName = ''
    const primaryContact = getPrimaryContact(company)
    if(primaryContact){
        preferredName = primaryContact.contact.preferred_name
    }
    return preferredName
}

function getPrimaryContactLinkedin(company) {
    let linkedin = ''
    const primaryContact = getPrimaryContact(company)
    if(primaryContact){
        linkedin = primaryContact.contact.linkedin_profile
    }
    return linkedin
}

function getPrimaryContactTitle(company) {
    let title = ''
    const primaryContact = getPrimaryContact(company)
    if(primaryContact){
        title = primaryContact.title
    }
    return title
}

function getPrimaryContactEmail(company) {
    let email = ''
    const primaryContact = getPrimaryContact(company)
    if(primaryContact){
        return primaryContact.email_address
    }
    return email
}

function getPrimaryContactPhone(company) {
    let phone = ''
    const primaryContact = getPrimaryContact(company)
    if(primaryContact){
        primaryContact.phone_number
    }
    return phone
}

function getMostRecentCRMStatus(company) {
    let crmStatus = ''
    if(company.crm_statuses.length > 0 && company.campaign){
        console.log('crm statuses', company.crm_statuses)
        const returnStatus = company.crm_statuses.filter((status) => {
            return status.campaign.id === company.campaign.id 
        })
        if(returnStatus.length > 0){
            return returnStatus[0].crm_status.status_name
        }
    }
    return crmStatus
}

// A CRM detail counts as completed once it has a resolved_date -- the status
// field is deprecated. Details belonging to other campaigns are skipped when the
// company is on a campaign; a company with no campaign falls back to its most
// recent completed detail across all campaigns.
function getLastCompletedCRMDetail(company) {
    if(!company.crm_actions){
        return null
    }
    const campaignId = company.campaign ? company.campaign.id : null
    const completedDetails = company.crm_actions.filter((detail) => {
        if(!detail.resolved_date){
            return false
        }
        return campaignId ? detail.campaign_id === campaignId : true
    })
    if(completedDetails.length === 0){
        return null
    }
    // id breaks ties between details resolved on the same day -- resolved_date is
    // a date, so same day details are otherwise unordered.
    return completedDetails.reduce((mostRecent, currentDetail) => {
        const mostRecentDate = new Date(mostRecent.resolved_date).getTime()
        const currentDate = new Date(currentDetail.resolved_date).getTime()
        if(currentDate > mostRecentDate || (currentDate === mostRecentDate && currentDetail.id > mostRecent.id)){
            return currentDetail
        }
        return mostRecent
    })
}

function getLastCRMDetail(company) {
    const lastDetail = getLastCompletedCRMDetail(company)
    if(!lastDetail){
        return ''
    }
    if(lastDetail.action && lastDetail.action.action_name){
        return lastDetail.action.action_name
    }
    return lastDetail.action_name ? lastDetail.action_name : ''
}

function getLastCRMDetailDate(company) {
    const lastDetail = getLastCompletedCRMDetail(company)
    return lastDetail ? lastDetail.resolved_date : ''
}

function getCampaignName(company) {
    return company.campaign ? company.campaign.campaign_name : ''
}

function getClientName(company) {
    return company.campaign ? company.campaign.client ? company.campaign.client.client_name : '' : ''
}

function getTier(company) {
    return company.tier_object ? company.tier_object.tier_name : ''
}

function getURLVettedBy(company) {
    return company.url_vetted_by ? company.url_vetted_by.first_name + " " + company.url_vetted_by.last_name : ''
}

function getZoomInfoId(company) {
    return company.zoom_info_company ? company.zoom_info_company.zoom_info_id : '';
}

function getZoomInfoRevenue(company) {
    return company.zoom_info_company ? company.zoom_info_company.revenue : '';
}

function getZoomInfoEmployeeHeadcount(company) {
    return company.zoom_info_company ? company.zoom_info_company.employee_count : '';
}

function getZoomInfoWebsiteURL(company) {
    return company.zoom_info_company ? company.zoom_info_company.website : '';
}

function getZoomInfoLocation(company) {
    let zoomInfoLocation = ''
    if(company.zoom_info_company){
        if(company.zoom_info_company.street) {
            zoomInfoLocation += `${company.zoom_info_company.street}\n`
        }
        if(company.zoom_info_company.city) {
            zoomInfoLocation += `${company.zoom_info_company.city}, `
        }
        if(company.zoom_info_company.state) {
            zoomInfoLocation += `${company.zoom_info_company.state} `
        }
        if(company.zoom_info_company.zip_code) {
            zoomInfoLocation += `${company.zoom_info_company.zip_code} `
        }
        if(company.zoom_info_company.country) {
            zoomInfoLocation += company.zoom_info_company.country
        }
    }
    return zoomInfoLocation;   
}

export function createCSV(fields, companies, csvType) {
    // console.log('companies', companies)
    let csvContent = "";
    csvContent += fields.join(",") + "\r\n"
    let counter = 0
    companies.forEach((company) => {
        counter++
        let companyRow = []
        fields.forEach((field) => {
            if(field == 'primary_contact_full_name'){
                companyRow.push('"'+getPrimaryContactFullName(company)+'"')
            } else if(field == 'primary_contact_preferred_name'){
                companyRow.push('"'+getPrimaryContactPreferredName(company)+'"')
            } else if(field == 'primary_contact_title'){
                companyRow.push('"'+getPrimaryContactTitle(company)+'"')
            } else if(field == 'primary_contact_email'){
                companyRow.push('"'+getPrimaryContactEmail(company)+'"')
            } else if(field == 'primary_contact_linkedin'){
                companyRow.push('"'+getPrimaryContactLinkedin(company)+'"')
            } else if(field == 'primary_contact_phone'){
                companyRow.push('"'+getPrimaryContactPhone(company)+'"')
            } else if(field == 'zoom_info_id') {
                companyRow.push('"'+getZoomInfoId(company)+'"')
            } else if(field == 'zoom_info_url') {
                companyRow.push('"'+getZoomInfoWebsiteURL(company)+'"')
            } else if(field == 'zoom_info_location') {
                companyRow.push('"'+getZoomInfoLocation(company)+'"')
            } else if(field == 'zoom_info_revenue') {
                companyRow.push('"'+getZoomInfoRevenue(company)+'"')
            } else if(field == 'zoom_info_employee_headcount') {
                companyRow.push('"'+getZoomInfoEmployeeHeadcount(company)+'"')
            } else if(field == 'crm_status'){
                companyRow.push('"'+getMostRecentCRMStatus(company)+'"')
            } else if(field == 'last_crm_detail'){
                companyRow.push('"'+getLastCRMDetail(company)+'"')
            } else if(field == 'last_crm_detail_date'){
                companyRow.push('"'+getLastCRMDetailDate(company)+'"')
            } else if(field == 'campaign'){
                companyRow.push('"'+getCampaignName(company)+'"')
            } else if(field == 'client'){
                companyRow.push('"'+getClientName(company)+'"')
            } else if(field == 'tier_object'){
                companyRow.push('"'+getTier(company)+'"')
            } else if(field == 'url_vetted_by'){
                companyRow.push('"'+getURLVettedBy(company)+'"')
            } else if(field == 'client_feedback'){
                // The latest feedback recorded for the company's current client
                companyRow.push('"'+(company.current_client_feedback ?? '')+'"')
            } else if(field == 'client_feedback_notes'){
                // Every note for the company's current client, newest first
                const notes = (company.current_client_feedback_notes ?? []).map((note) => note.notes).filter(Boolean).join('\n\n')
                companyRow.push('"'+notes.replaceAll('"', "'")+'"')
            } else {
                let companyField = company[field]
                if(typeof companyField == 'string') {
                    companyField = companyField.replaceAll('"', "'")
                }
                if(!companyField && companyField !== 0){
                    companyField = ''
                }
                companyRow.push('"'+companyField+'"')
            }
        })
        csvContent += companyRow.join(",") + "\r\n"
    })
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        if(csvType == 'company'){
            link.setAttribute("download", "company_export.csv");
        } else if (csvType == 'pma') {
            link.setAttribute("download", "pma_export.csv");
        }
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export function createZIUploadCsv(companies) {
    // console.log('companies', companies)
    let csvContent = "zoom_info_id,company_name";
    csvContent += "\r\n"
    let counter = 0
    companies.forEach((company) => {
        counter++
        let companyRow = []
        if(company.zoom_info_company){
            companyRow.push(company.zoom_info_company.zoom_info_id)
            companyRow.push('"'+company.zoom_info_company.company_name.replaceAll('"', "'")+'"')
        }
        csvContent += companyRow.join(",") + "\r\n"
    })
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "zoom_info_id_export.csv");
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export function getCompanyFields() {
    const companyFields = [
        'id',
        'company_name',
        'doing_business_as',
        'website_url',
        'campaign',
        'tier_object',
        'account_manager_research_notes',
        'address',
        'city',
        'state', 
        'zip',
        'country',
        'parent_company',
        'investors',
        'revenue',
        'employee_headcount',
        'client_feedback',
        'client_feedback_notes',
        'crm_status',
        'crm_next_action',
        'crm_next_action_due_date',
        'last_crm_detail',
        'last_crm_detail_date',
        'square_footage',
        'zoom_info_id',
        'zoom_info_url',
        'zoom_info_location',
        'zoom_info_revenue',
        'zoom_info_employee_headcount',
        'relevant_business',
        'client_update_notes',
        'out_reach_notes',
        'primary_contact_full_name',
        'primary_contact_preferred_name',
        'primary_contact_title',
        'primary_contact_email',
        'primary_contact_phone',
        'primary_contact_linkedin'
    ]
    return companyFields
}
